import { CartItemUpdateStorefrontDto } from '@VelocitySquared/sunny16-commerce-dataobjects/storefront'

export class CartItemSelection {
  cartBundleId: string | null
  // Null when the cart bundle's catalog bundle is not in the loaded catalog; the selection is still
  // sent, it just has no radio group on the page.
  itemGroupId: string | null
  itemGroupItemId: string
  itemId: string

  constructor(
    cartBundleId: string | null,
    itemGroupId: string | null,
    itemGroupItemId: string,
    itemId: string
  ) {
    this.cartBundleId = cartBundleId
    this.itemGroupId = itemGroupId
    this.itemGroupItemId = itemGroupItemId
    this.itemId = itemId
  }

  static fromPlainObject(obj: CartItemSelection): CartItemSelection {
    return new CartItemSelection(obj.cartBundleId, obj.itemGroupId, obj.itemGroupItemId, obj.itemId)
  }

  toCartItemUpdateStorefrontDto(): CartItemUpdateStorefrontDto {
    return {
      itemGroupItemId: this.itemGroupItemId,
      itemId: this.itemId
    }
  }
}
